import { baseURL } from "../../Shared/Networking/constants";
import { jsonRequest } from "../../Shared/Networking/rest-client";

export class RemoteEmployeesRepository {
    constructor(branch, business) {
        this.branch = branch
        this.business = business
    }

    async getAll() {
        const url = `${baseURL}/businesses/${this.business}/branches/${this.branch}/employees`
        return await jsonRequest(`${url}`).then(response => response.data)
    }

    async create(employee) {
        const url = `${baseURL}/businesses/${this.business}/branches/${this.branch}/employees`
        return await jsonRequest(`${url}`, { method: 'POST', body: employee })
    }

    async update(employee) {
        const url = `${baseURL}/businesses/${this.business}/branches/${this.branch}/employees`
        return await jsonRequest(`${url}`, { method: 'PUT', body: employee })
    }
}
